export default function MyProfile() {
  return (
    <div className="container-fluid bg-light min-vh-100 p-4">
      <div className="row mt-4 mb-5">
        {/* Sidebar */}
        <div className="col-md-3 mb-4 ">
          <div className="list-group rounded">
            <a
              href="/"
              className="list-group-item list-group-item-action border-0 text-success fw-semibold"
            >
              <i className="fa-regular fa-user me-2" />
              My Profile
            </a>
            <a
              href="/"
              className="list-group-item list-group-item-action border-0"
            >
              <i className="fa-regular fa-bookmark me-2" />
              My Bookings
            </a>
            <a
              href="/"
              className="list-group-item list-group-item-action border-0"
            >
              <i className="fa-solid fa-users me-2" />
              My Family & Friends
            </a>
          </div>
        </div>

        {/* Profile Content */}
        <div className="col-md-5">
          <h4 className="fw-semibold mb-4">Profile Details</h4>

          {/* Profile Items */}
          <div className="d-flex align-items-center justify-content-between bg-white p-3 rounded mb-3">
            <div className="d-flex align-items-center">
              <img
                style={{ objectFit: "contain" }}
                height={50}
                width={50}
                src="https://t4.ftcdn.net/jpg/02/18/93/97/360_F_218939757_YqHgeD3BAANU87y2Kc10Y40HNVgDv5rK.jpg"
                alt="profile"
                className="rounded-circle me-3"
              />
              <div>
                <div
                  className="fw-bold small text-uppercase py-2"
                  style={{ color: "#F88922" }}
                >
                  Name
                </div>
                <div className="py-2">Mr. Ashiqul Islam</div>
              </div>
            </div>
            <a
              href="/"
              className="text-success small fw-semibold text-decoration-none"
            >
              Edit
            </a>
          </div>

          <div className="bg-white p-3 rounded mb-3">
            <div
              className="fw-bold small text-uppercase py-2"
              style={{ color: "#F88922" }}
            >
              Email
            </div>
            <div>username@domain.com</div>
          </div>

          <div className="bg-white p-3 rounded mb-3">
            <div
              className="fw-bold small text-uppercase py-2"
              style={{ color: "#F88922" }}
            >
              Phone
            </div>
            <div>01788888888</div>
          </div>

          <div className="d-flex justify-content-between bg-white p-3 rounded mb-3">
            <div>
              <div
                className="fw-bold small text-uppercase py-2"
                style={{ color: "#F88922" }}
              >
                Address
              </div>
              <div className="py-2">
                House #55/B Rd No # 21, Dhaka 1213, Bangladesh
              </div>
            </div>
            <a
              href="/"
              className="text-success small fw-semibold text-decoration-none"
            >
              Edit
            </a>
          </div>

          <div className="d-flex justify-content-between bg-white p-3 rounded mb-3">
            <div>
              <div
                className="fw-bold small text-uppercase py-2"
                style={{ color: "#F88922" }}
              >
                Password
              </div>
              <div className="py-2">●●●●●●●●●</div>
            </div>
            <a
              href="/"
              className="text-success small fw-semibold text-decoration-none"
            >
              Edit
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
